import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { 
    IonContent, IonModal, IonSpinner, IonIcon
} from '@ionic/angular/standalone';

import { DemoozModalService } from '@demooz/services';

@Component({
    selector: 'demooz-modal-media',
    templateUrl: './modal-media.component.html',
    styleUrls: ['./modal-media.component.scss'],
    imports: [IonContent, IonModal, IonSpinner, IonIcon]
})
export class DemoozModalMediaComponent  implements OnInit {

    @ViewChild('modalMedia') modalMedia: IonModal;
    
    isFetchingMedia: boolean = false;
    isVideo: boolean = false;
    urlMedia: string|null = null;

    constructor(
        private demoozModalService: DemoozModalService
    ) { }

    ngOnInit() {}
    
    open(urlMedia: string) {
        this.isFetchingMedia = true;        
        this.isVideo =  (new RegExp('\.mp4$')).test(urlMedia);
        this.urlMedia = urlMedia;        
        this.demoozModalService.open(this.modalMedia);
    }
    
    onLoadMedia(){
        this.isFetchingMedia = false;       
    }
    
    async dismiss() {        
        await this.modalMedia.dismiss();
    }
    
    async canDismissMediaModal(data?: any, role?: string) {
        return role !== 'gesture';
    }
    
    async onDidDismissMediaModal($event: any){  
        this.isFetchingMedia = false;
        this.isVideo = false;
        this.urlMedia = null;
        this.demoozModalService.onDidDismiss($event);
    }
}
